import { call, put, takeLatest, select } from 'redux-saga/effects';
import actionTypes from '../../actions/actionTypes';
import { getPagesCall, getWPDataCall, getServicePagesCall, getMenuItemsCall, updateWPDataCall } from '../../apis/wpApi/apiCalls'
import authUser from '../../apis/wpApi/authUser';


const getlocalData = () => (state) => {
    let data = state.getIn(['wpLocalData', 'data', 'data'])

    if(data !== null) {
        data = data.toJS()
    }

    return {
        "data": data
    }
}

function* putSuccess(successActionType, payload) {
    yield put({
        type: successActionType, 
        payload: payload
    })
}

function* putError(errorActionType, errorMessage) {
    yield put({
        type: errorActionType, 
        payload: {
            errorMessage: errorMessage
        }
    })
}

function* orderedItemsApiCall(callFunction, signal, successActionType, errorActionType) {
    try {
        const apiKey = yield call(authUser.getToken)
        const response = yield call(callFunction, apiKey, signal)

        yield putSuccess(successActionType, response.data)
    } catch(e) {
        yield putError(errorActionType, e.message)
    }
}



function* getPages({payload}){
    yield orderedItemsApiCall(getPagesCall, payload.signal, actionTypes.WP_PAGES_GET_SUCCESS, actionTypes.WP_PAGES_GET_ERROR);
}

function* getServicePages({payload}){
    yield orderedItemsApiCall(getServicePagesCall, payload.signal, actionTypes.WP_SERVICEPAGES_GET_SUCCESS, actionTypes.WP_SERVICEPAGES_GET_ERROR);
}

function* getMenuItems({payload}){
    yield orderedItemsApiCall(getMenuItemsCall, payload.signal, actionTypes.WP_MENUITEMS_GET_SUCCESS, actionTypes.WP_MENUITEMS_GET_ERROR);
}

function* getData({payload}) {
    yield orderedItemsApiCall(getWPDataCall, payload.signal, actionTypes.WP_DATA_GET_SUCCESS, actionTypes.WP_DATA_GET_ERROR);
}

function* updateData() {
    try {
        const apiKey = yield call(authUser.getToken)
        const localData = yield select(getlocalData())
        const response = yield call(updateWPDataCall, apiKey, localData)

        yield putSuccess(actionTypes.WP_DATA_UPDATE_SUCCESS, response.data.data)
    }catch(e){
        yield putError(actionTypes.WP_DATA_UPDATE_ERROR, e.message)
    }
}

function* wpSaga() {
    yield takeLatest(actionTypes.WP_PAGES_GET_REQUEST, getPages);
    yield takeLatest(actionTypes.WP_SERVICEPAGES_GET_REQUEST, getServicePages);
    yield takeLatest(actionTypes.WP_MENUITEMS_GET_REQUEST, getMenuItems);
    yield takeLatest(actionTypes.WP_DATA_GET_REQUEST, getData);
    yield takeLatest(actionTypes.WP_DATA_UPDATE_REQUEST, updateData)
}

export default wpSaga;